























import Vue from 'vue';
import Component from 'vue-class-component'
import { Resolve } from 'vue-di';
import { Title } from '~/decorators/Title';
import { Settings } from '~/services/settings';
@Component<Unlock>({
    layout: 'lock',
    middleware(ctx: any) {
        if(
            ((/true/i).test(ctx.env.lockEnabled) && ctx.$passwordProtect.isAuthorised())
            ||
            (!(/true/i).test(ctx.env.lockEnabled))
        ){
            ctx.redirect({ path: '/' });
        }
    }
})
@Title('Please Unlock To Gain Access')
export default class Unlock extends Vue {
    @Resolve
    settings!: Settings;
    password = '';

    handleSubmit(){
        if(this.$passwordProtect.authorise(this.password) && this.$passwordProtect.isAuthorised()){
            this.$router.push({ path: '/' });
        }
    }
}
